import { Box } from '@mui/material';
import { Button } from '../../../../Components/MUIs';

export default function PerButton({
  onCancel,
  onClick,
  cancelText = '취소',
  saveText = '다음',
  cancelColor = '#776D6D',
  saveColor = '#57B84D',
}) {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
      <button
        style={{
          width: '40%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: 'transparent',
          border: `1px solid ${cancelColor}`,
          color: cancelColor,
          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={onCancel}
      >
        {cancelText}
      </button>

      <Button
        name={saveText}
        sx={{
          width: '60%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: saveColor,
          color: '#fff',
          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={onClick}
      />
    </Box>
  );
}
